import { Injectable } from "@angular/core";
import { EnumGlobals } from "src/app/common/enum/Enums";
import { Periodo } from "src/app/model/Globals/periodos.model";
import { EnumTipoCoordenada } from "src/app/common/enum/TipoPersona.enum";
import { saveAs } from "file-saver";

@Injectable({
  providedIn: "root",
})
export class Helper {
  private Periodo: Periodo = new Periodo();
  private Periodos: Periodo[] = [];

  constructor() {}

  public getCoordinates(Coordenadas: string, Tipo: number) {
    const coordenadasArray = Coordenadas.split(","); //Obtenemos arreglo de coordenadas

    let lat = coordenadasArray[EnumTipoCoordenada.Latitud].trim(); //Obtenemos Latitud
    let long = coordenadasArray[EnumTipoCoordenada.Longitud].trim(); //Obtenemos Longitud

    return Number(Tipo == EnumTipoCoordenada.Latitud ? lat : long); // Devolvemos valor
  }

  public stringFormat(format: string, ...args: any[]): string {
    return format.replace(/{(\d+)}/g, (match, index) => {
      const arg = args[index];
      return arg !== undefined ? arg : match;
    });
  }

  public getPeriodos() {
    this.Periodos = [];
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    var currentMonth = currentDate.getMonth();

    var minYear = currentYear - EnumGlobals.AnniosHistoricos;
    var item = currentYear;
    var Id = 1;

    while (item >= minYear) {
      var sizePeriod = item == currentYear ? (currentMonth < 7 ? 1 : 2) : 2;
      while (sizePeriod >= 1) {
        this.Periodo = new Periodo();
        var MaxDay = sizePeriod == 2 ? 31 : 30;
        var MaxMonth = sizePeriod == 1 ? 5 : 11;
        var IniMonth = sizePeriod == 1 ? 0 : 6;
        this.Periodo.PeriodoId = Id;
        this.Periodo.Periodo =
          item + " " + (sizePeriod == 1 ? "Primer" : "Segundo") + " Periodo";
        this.Periodo.FechaInicio = new Date(item, IniMonth, 1);
        this.Periodo.FechaFin = new Date(item, MaxMonth, MaxDay);
        this.Periodos.push(this.Periodo);
        sizePeriod--;
        Id++;
      }
      item--;
    }

    return this.Periodos;
  }

  public getAnnio() {
    this.Periodos = [];
    var currentDate = new Date();
    var currentYear = currentDate.getFullYear();
    var currentMonth = currentDate.getMonth();

    var minYear = currentYear - EnumGlobals.AnniosHistoricos;
    var item = currentYear;
    var Id = 1;

    while (item >= minYear) {
      this.Periodo = new Periodo();
      this.Periodo.PeriodoId = Id;
      this.Periodo.Periodo = item.toString();
      this.Periodo.FechaInicio = new Date(item, 0, 1);
      this.Periodo.FechaFin = new Date(item, 11, 31);
      this.Periodos.push(this.Periodo);
      Id++;
      item--;
    }

    return this.Periodos;
  }

  validarTexto(event: KeyboardEvent, text: string, numCaharacter: number) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-zA-ZñÑ0-9,./* ]/.test(inp)) {
      let stringArr = typeof text === "undefined" ? "" : text.split(/(\s+)/);
      var character = stringArr != "" ? stringArr[stringArr.length - 1] : "";
      var numCaharacters = typeof text === "undefined" ? 1 : text.length;

      if (inp == " " && character == "") {
        return false;
      } else if (numCaharacters == numCaharacter) {
        return false;
      } else {
        return inp == "  " ? false : true;
      }
    } else {
      event.preventDefault();
      return false;
    }
  }

  validarNumeros(
    event: KeyboardEvent,
    number: number,
    MaxValue: number,
    MinValue: number,
  ) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[0-9.]/.test(inp)) {
      number = Number(number.toString() + inp);
      if (number < MinValue || number > MaxValue) {
        return false;
      }
    } else {
      event.preventDefault();
      return false;
    }
  }

  validarSoloTexto(event: KeyboardEvent, text, numCaharacter) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-no-z,A-NO-Z ]/.test(inp)) {
      let stringArr = typeof text === "undefined" ? "" : text.split(/(\s+)/);
      var character = stringArr != "" ? stringArr[stringArr.length - 1] : "";
      var numCaharacters = typeof text === "undefined" ? 1 : text.length;

      if (inp == " " && character == "") {
        return false;
      } else if (numCaharacters == numCaharacter) {
        return false;
      }
    } else {
      event.preventDefault();
      return false;
    }
  }

  validarLogin(event: KeyboardEvent, text: string, numCaharacter: number) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[a-no-z,A-NO-Z0-9]/.test(inp)) {
      let stringArr = typeof text === "undefined" ? "" : text.split(/(\s+)/);
      var character = stringArr != "" ? stringArr[stringArr.length - 1] : "";
      var numCaharacters = typeof text === "undefined" ? 1 : text.length;

      if (inp == " " && character == "") {
        return false;
      } else if (numCaharacters == numCaharacter) {
        return false;
      } else {
        return inp == "  " ? false : true;
      }
    } else {
      event.preventDefault();
      return false;
    }
  }

  updateBackgroundStyle(env: string) {
    const svgUrl = this.getEnvironmentSvg(env);
    const combinedStyle = `url("${svgUrl}"), url("assets/images/bg.png")`;
    return {
      "background-image": combinedStyle,
      "background-size": "cover",
      "background-cover": "full",
      "background-position": "center",
      "background-repeat": "no-repeat",
      "background-attachment": "fixed",
    };
  }

  getEnvironmentSvg(env: string): string {
    const txt = Array(50).fill(env).join("\u00A0\u00A0\u00A0\u00A0\u00A0");
    const repeats = 10;
    const spacing = 200;
    const size = repeats * spacing;

    let elements = "";
    for (let i = 0; i < 30; i++) {
      elements += `
      <text x="${i * 80}" y="${i * 50}" 
        font-family="Arial, sans-serif" 
        font-size="40" 
        font-weight="bold"
        fill="rgba(22, 21, 22, 0.1)" 
        transform="rotate(-45 ${i * spacing} ${i * spacing})">
        ${txt}
      </text>
    `;
    }

    const svgContent = `
      <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" style="background:transparent;">
        ${elements}
      </svg>
    `;

    return "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgContent);
  }

  validarMontos(event: KeyboardEvent, text, numCaharacter) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[0-9.$]/.test(inp)) {
      let stringArr = typeof text === "undefined" ? "" : text.split(/(\s+)/);
      var character = stringArr != "" ? stringArr[stringArr.length - 1] : "";
      var numCaharacters = typeof text === "undefined" ? 1 : text.length;

      if (inp == " " && character == "") {
        return false;
      } else if (numCaharacters == numCaharacter) {
        return false;
      }
    } else {
      event.preventDefault();
      return false;
    }
  }

  getMoneyToFloat(input: string) {
    let limpio = input.replace(/[^0-9.]/g, "");
    let montoDecimal = parseFloat(limpio);
    return montoDecimal;
  }

  downloadFiles(response: any) {
    response.forEach((archivo: any) => {
      const byteString = atob(archivo.valueArchivo);

      const ab = new ArrayBuffer(byteString.length);
      const ia = new Uint8Array(ab);

      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      const blob = new Blob([ab], { type: archivo.fileType });
      saveAs(blob, archivo.fileName);
    });
  }
}
